import { Component } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminHotelNavbarComponent } from '../../../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { NavbarComponent } from "../../../../components/navbar/navbar.component";
//import { Producto } from '../../../../interfaces/productos/product.interface';
//import { ProductosPorEstadiaService } from '../../../../services/productsbyestadia/productos-por-estadia.service';

export interface Producto {
  id: number | string;
  nombre: string;
  descripcion_corta: string;
  valor_neto: number;
}

@Component({
  selector: 'app-listar-productos',
  standalone: true,
  imports: [AdminHotelNavbarComponent, FooterComponent, NgIf, NgFor, CommonModule, NavbarComponent],
  templateUrl: './listar-productos.component.html',
  styleUrl: './listar-productos.component.css'
})
export class ListarProductosComponent {
  productos: Producto[] = [
    {
      id: 1,
      nombre: 'Gaseosa 500ml',
      valor_neto: 3500,
      descripcion_corta: 'Bebida refrescante',
    },
    {
      id: 2,
      nombre: 'Snack de papas',
      valor_neto: 2500,
      descripcion_corta: 'Bolsa de papas fritas',
    },
    {
      id: 3,
      nombre: 'Agua mineral',
      valor_neto: 2000,
      descripcion_corta: 'Botella de agua 600ml',
    }
  ];
  estadiaId: string | null = null;

  constructor(
    //private productosService: ProductosPorEstadiaService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    // estadiaId de los query parameters
    this.route.queryParamMap.subscribe((params) => {
      const id = params.get('estadiaId');
      if (id) {
        this.estadiaId = id;
        this.obtenerProductos();
      } else {
        console.error('No se encontró estadiaId en la URL');
      }
    });
  }

  obtenerProductos(): void {
    /*if (this.estadiaId) {
      this.productosService.getProductosPorEstadia(this.estadiaId).subscribe({
        next: (data) => {
          this.productos = data.reverse();
        },
        error: (err) => {
          console.error('Error al obtener productos:', err);
        }
      });
    }*/
  }

  editarProducto(producto: Producto): void {
    this.router.navigate(['/admin-hotel/inventario/editar-producto', producto.id], { queryParams: { estadiaId: this.estadiaId } });
  }
}